import React from 'react';
import styled from 'styled-components';

import { layout } from '@prisjakt/ui-base';

import Clickable from '@prisjakt/ui-clickable';
import { IconDiagonalArrowUpLeft } from '@prisjakt/ui/icon';

type Props = {
  onClick: () => void;
};

export const ExtendSearchButton = (props: Props) => {
  const { onClick } = props;

  const handleClick = (e: React.MouseEvent) => {
    e.preventDefault();
    e.stopPropagation();
    onClick();
  };

  return (
    <Button data-test="ExtendSearchButton" onClick={handleClick}>
      <IconDiagonalArrowUpLeft size={13} color="base500" />
    </Button>
  );
};

const Button = styled(Clickable)`
  display: flex;
  justify-content: center;
  align-items: center;
  height: 24px;
  width: 24px;
  background-color: ${p => p.theme.bg.secondary};
  border-radius: 50%;
  color: ${p => p.theme.icons.secondary};
  position: absolute;
  top: 50%;
  right: ${layout.measurements.spacing100};
  transform: translateY(-50%);
  cursor: pointer;

  &:hover {
    background-color: ${p => p.theme.bg.tertiary};
  }
`;
